import { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { ArrowLeft, Mail, CheckCircle2, Info } from "lucide-react";
import { toast } from "sonner";
import axios from "axios";

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API_URL}/api/auth/forgot-password?email=${encodeURIComponent(email)}`);
      setSent(true);
    } catch (err) {
      toast.error("Erreur lors de l'envoi, réessayez.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-8 bg-background">
      <div className="w-full max-w-md animate-fade-in">
        <div className="flex items-center gap-3 mb-10">
          <img src="/logo.png" alt="AMCPhone" className="w-12 h-12 rounded-md object-contain" />
          <div>
            <h1 className="font-chivo font-bold text-2xl text-foreground">AMCPhone</h1>
            <p className="text-sm text-muted-foreground">Martinique</p>
          </div>
        </div>

        {!sent ? (
          <>
            <h2 className="font-chivo text-3xl font-bold text-foreground mb-2">Mot de passe oublié</h2>
            <p className="text-muted-foreground mb-8">
              Entrez votre email d'administrateur. Nous vous enverrons un lien pour réinitialiser votre mot de passe.
            </p>

            {/* Info employé */}
            <div className="flex gap-3 p-4 rounded-lg bg-amber-500/10 border border-amber-500/30 mb-6">
              <Info className="w-5 h-5 text-amber-500 shrink-0 mt-0.5" />
              <div className="text-sm text-muted-foreground">
                <p className="font-medium text-foreground mb-1">Vous êtes employé ?</p>
                <p>La réinitialisation par email est réservée aux administrateurs. Contactez votre administrateur pour qu'il réinitialise votre mot de passe depuis l'onglet <strong>Employés</strong>.</p>
              </div>
            </div>

            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="space-y-2">
                <Label htmlFor="email">Email administrateur</Label>
                <Input
                  id="email"
                  type="email"
                  placeholder="admin@exemple.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="bg-secondary/50 border-border focus:border-primary"
                />
              </div>
              <Button type="submit" disabled={loading} className="w-full bg-primary hover:bg-primary/90">
                <Mail className="w-4 h-4 mr-2" />
                {loading ? "Envoi en cours..." : "Envoyer le lien"}
              </Button>
            </form>
          </>
        ) : (
          <div className="text-center space-y-4">
            <div className="w-16 h-16 bg-emerald-500/20 rounded-full flex items-center justify-center mx-auto">
              <CheckCircle2 className="w-8 h-8 text-emerald-500" />
            </div>
            <h2 className="font-chivo text-2xl font-bold text-foreground">Email envoyé !</h2>
            <p className="text-muted-foreground">
              Si l'adresse <strong>{email}</strong> correspond à un compte administrateur,
              vous recevrez un lien de réinitialisation dans quelques minutes.
            </p>
            <p className="text-sm text-muted-foreground">Le lien est valable 2 heures.</p>
          </div>
        )}

        <div className="mt-8 text-center">
          <Link to="/login" className="text-sm text-muted-foreground hover:text-primary flex items-center justify-center gap-1">
            <ArrowLeft className="w-4 h-4" />
            Retour à la connexion
          </Link>
        </div>
      </div>
    </div>
  );
}
